var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/picture-element-macro.j2"] = require( "macros/picture-element-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/components/image-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/contentful/components/image-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_4 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_4);
env.getTemplate("macros/picture-element-macro.j2", false, "core/templates/macros/contentful/components/image-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("pictureElement")) {
var t_8 = t_5.pictureElement;
} else {
cb(new Error("cannot import 'pictureElement'")); return;
}
context.setVariable("pictureElement", t_8);
var macro_t_9 = runtime.makeMacro(
[], 
["entry", "experience", "defaultEventCategory", "defaultEventAction"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", kwargs.hasOwnProperty("entry") ? kwargs["entry"] : {});
frame.set("experience", kwargs.hasOwnProperty("experience") ? kwargs["experience"] : {});
frame.set("defaultEventCategory", kwargs.hasOwnProperty("defaultEventCategory") ? kwargs["defaultEventCategory"] : "");
frame.set("defaultEventAction", kwargs.hasOwnProperty("defaultEventAction") ? kwargs["defaultEventAction"] : "");
var t_10 = "";if((lineno = 5, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.url"]))) {
t_10 += "\n\n        ";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"url");
frame.set("wrapperURL", t_11, true);
if(frame.topLevel) {
context.setVariable("wrapperURL", t_11);
}
if(frame.topLevel) {
context.addExport("wrapperURL", t_11);
}
t_10 += "\n\n    ";
;
}
else {
if((lineno = 9, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.backgroundImage.fields.url"]))) {
t_10 += "\n\n        ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"backgroundImage")),"fields")),"url");
frame.set("wrapperURL", t_12, true);
if(frame.topLevel) {
context.setVariable("wrapperURL", t_12);
}
if(frame.topLevel) {
context.addExport("wrapperURL", t_12);
}
t_10 += "\n\n    ";
;
}
;
}
t_10 += "\n\n    <!-- Image Component -->\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "wrapperURL")) {
t_10 += "\n\n        ";
var t_13;
t_13 = (lineno = 19, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.useSweetScroll",false]));
frame.set("useSweetScroll", t_13, true);
if(frame.topLevel) {
context.setVariable("useSweetScroll", t_13);
}
if(frame.topLevel) {
context.addExport("useSweetScroll", t_13);
}
t_10 += "\n        ";
var t_14;
t_14 = (lineno = 20, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.jsClassName",false]));
frame.set("jsClassName", t_14, true);
if(frame.topLevel) {
context.setVariable("jsClassName", t_14);
}
if(frame.topLevel) {
context.addExport("jsClassName", t_14);
}
t_10 += "\n        ";
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "useSweetScroll") && runtime.contextOrFrameLookup(context, frame, "jsClassName")?"#":(lineno = 21, colno = 76, runtime.callWrap(t_4, "contentfulUrl", context, [runtime.contextOrFrameLookup(context, frame, "wrapperURL")])));
frame.set("href", t_15, true);
if(frame.topLevel) {
context.setVariable("href", t_15);
}
if(frame.topLevel) {
context.addExport("href", t_15);
}
t_10 += "\n\n        ";
t_10 += "\n        ";
var t_16;
t_16 = (runtime.contextOrFrameLookup(context, frame, "defaultEventCategory")?runtime.contextOrFrameLookup(context, frame, "defaultEventCategory"):runtime.contextOrFrameLookup(context, frame, "eventCategory"));
frame.set("eventCategory", t_16, true);
if(frame.topLevel) {
context.setVariable("eventCategory", t_16);
}
if(frame.topLevel) {
context.addExport("eventCategory", t_16);
}
t_10 += "\n        ";
var t_17;
t_17 = (runtime.contextOrFrameLookup(context, frame, "defaultEventAction")?runtime.contextOrFrameLookup(context, frame, "defaultEventAction"):runtime.contextOrFrameLookup(context, frame, "eventAction"));
frame.set("eventAction", t_17, true);
if(frame.topLevel) {
context.setVariable("eventAction", t_17);
}
if(frame.topLevel) {
context.addExport("eventAction", t_17);
}
t_10 += "\n\n        <a\n            href=\"";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "href"), env.opts.autoescape);
t_10 += "\"\n            ";
if(runtime.contextOrFrameLookup(context, frame, "jsClassName")) {
t_10 += " class=\"";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsClassName"), env.opts.autoescape);
t_10 += "\" ";
;
}
t_10 += "\n            ";
if((lineno = 33, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.openLinkInNewWindow",false]))) {
t_10 += " target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
t_10 += "\n\n            ";
t_10 += runtime.suppressValue((lineno = 35, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "eventCategory"),runtime.contextOrFrameLookup(context, frame, "eventAction"),runtime.contextOrFrameLookup(context, frame, "wrapperURL")])), env.opts.autoescape);
t_10 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "categoryContentContext") || runtime.contextOrFrameLookup(context, frame, "category") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"landingPage")) {
var t_18;
t_18 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"landingPage")?"LANDING":runtime.contextOrFrameLookup(context, frame, "categoryContentContext"));
frame.set("categorySiteContentContext", t_18, true);
if(frame.topLevel) {
context.setVariable("categorySiteContentContext", t_18);
}
if(frame.topLevel) {
context.addExport("categorySiteContentContext", t_18);
}
if(runtime.contextOrFrameLookup(context, frame, "categorySiteContentContext") == "PAGE_INLINE") {
t_10 += "\n                    ";
t_10 += runtime.suppressValue((lineno = 41, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","inline_content",(lineno = 41, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.alternateText",""]))])), env.opts.autoescape);
t_10 += "\n                ";
;
}
else {
t_10 += "\n                    ";
t_10 += runtime.suppressValue((lineno = 43, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","lead_content",(lineno = 43, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.alternateText",""]))])), env.opts.autoescape);
t_10 += "\n                ";
;
}
t_10 += "\n            ";
;
}
t_10 += "\n            class=\"c-landing-module__image-component\"\n        >\n\n    ";
;
}
t_10 += "\n\n    ";
t_10 += "\n    ";
t_10 += runtime.suppressValue((lineno = 52, colno = 19, runtime.callWrap(t_8, "pictureElement", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"isLazy": runtime.contextOrFrameLookup(context, frame, "isLazy"),"experience": runtime.contextOrFrameLookup(context, frame, "experience")})])), env.opts.autoescape);
t_10 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "wrapperURL")) {
t_10 += "\n\n        </a>\n\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("buildImage");
context.setVariable("buildImage", macro_t_9);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/components/image-macro.j2"] , dependencies)